import { Action } from '@ngrx/store';

import { ManagementOverviewActionType } from './management-overview-action-type.enum';

export class ResetManagementOverview implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.ResetManagementOverview;
  public readonly payload: string = undefined;
}
